import { Resources } from 'constants/resources';

import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useRecordContext } from 'react-admin';
import { Link, LinkProps } from 'react-router-dom';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';

export type ContextMenuUserActionsButtonProps = Omit<ContextMenuButtonProps, 'icon' | 'label'> & {
  linkProps?: Partial<LinkProps>;
};

export const ContextMenuUserActionsButton: React.FC<ContextMenuUserActionsButtonProps> = ({
  linkProps,
  ...restProps
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const record = useRecordContext();

  const to = createPathWithQuery(
    { resource: Resources.UserActions, type: 'list' },
    {
      filter: {
        user: [record?.id],
      },
    },
  );

  return (
    <Link
      style={{ textDecoration: 'none' }}
      target={linkProps?.target || '_self'}
      to={to}
      {...linkProps}
    >
      <ContextMenuButton
        icon={<PermContactCalendarIcon fontSize="small" style={{ marginTop: '1px' }} />}
        label="Действия пользователя"
        {...restProps}
      />
    </Link>
  );
};
